// "A new version is available. Refresh": a small, non-blocking note in the corner. It appears only when Shane is idle: nothing in the last 20 seconds, no composer or dialog open, no
// field being typed in, nothing selected in a list. At most once an hour. The page reloads ONLY when he taps Refresh (the place he was is saved and restored). Later hides it for the hour.
import React, { useEffect, useState } from 'react';
import Button from './Button';
import { onUpdateAvailable, mayShowToast, markToastShown, reloadNow } from '../lib/appUpdate';

export const IDLE_MS = 20000;

// Is he in the middle of something? A composer, a dialog, a field with the cursor in it, a checked row, a Compose or Hello screen.
export function isBusy(doc = document, hash = (typeof window !== 'undefined' ? window.location.hash : '')) {
  if (doc.querySelector('[role="dialog"], .tiptap, textarea, [contenteditable="true"]')) return true;
  const a = doc.activeElement;
  if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && a.type !== 'checkbox' && a.type !== 'button') return true;
  if (doc.querySelector('.charlie-main-content input[type="checkbox"]:checked')) return true;
  if (/(^|\/)compose(\?|$|\/)/.test(hash || '')) return true;
  return false;
}

export default function UpdateToast({ idleMs = IDLE_MS, pollMs = 3000 }) {
  const [available, setAvailable] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => onUpdateAvailable(() => setAvailable(true)), []);

  useEffect(() => {
    if (!available || visible) return undefined;
    let last = Date.now();
    const touch = () => { last = Date.now(); };
    const evs = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
    evs.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const t = setInterval(() => {
      if (Date.now() - last >= idleMs && !isBusy() && mayShowToast()) { markToastShown(); setVisible(true); }
    }, pollMs);
    return () => { clearInterval(t); evs.forEach((e) => window.removeEventListener(e, touch)); };
  }, [available, visible, idleMs, pollMs]);

  if (!visible) return null;
  return (
    <div role="status" data-testid="update-toast" style={{ position: 'fixed', left: 16, bottom: 16, zIndex: 400, background: '#fff', border: '1px solid var(--gov-slate-300)', borderRadius: 10, boxShadow: '0 6px 20px rgba(15,23,42,0.15)', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 10, maxWidth: 'calc(100vw - 32px)' }}>
      <span style={{ fontSize: 13, color: 'var(--gov-text-primary)' }}>A new version is available.</span>
      <Button size="sm" variant="primary" color="var(--gov-slate-700)" onClick={() => reloadNow()}>Refresh</Button>
      <Button size="sm" variant="secondary" onClick={() => setVisible(false)}>Later</Button>
    </div>
  );
}
